import { OnboardingLiveCreationIntentStatus } from "../gql/graphql.ts";
import { StatusBadge, StatusBadgeTone } from "../UI/StatusBadge.tsx";
import { creationIntentStatusLabels } from "./creationIntentStatusLabels.ts";

const toneByStatus: Record<
  OnboardingLiveCreationIntentStatus,
  StatusBadgeTone
> = {
  [OnboardingLiveCreationIntentStatus.Draft]: "neutral",
  [OnboardingLiveCreationIntentStatus.Confirmed]: "info",
  [OnboardingLiveCreationIntentStatus.Completed]: "success",
  [OnboardingLiveCreationIntentStatus.Cancelled]: "danger",
};

export function CreationIntentStatusBadge({
  status,
}: {
  status: OnboardingLiveCreationIntentStatus;
}) {
  return (
    <StatusBadge
      tone={toneByStatus[status]}
      label={creationIntentStatusLabels[status]}
    />
  );
}
